export default {
    accountTags_label: "Etiqueta",
    accountTags_units: "Unidades",
    accountTags_drivers: "Conductores",
    accountTags_landmarks: "Landmarks",
    accountTags_users: "Usuarios",
    accountTags_forms: "Formularios",
    accountTags_dynamicForms: "Formularios Dinámicos",
    accountTags_path: "Recorrido",
    accountTags_geofences: "Geofences",
    accountTags_assets: "Activos",
    accountTags_color: "Color (Formato Hex)",
    accountTags_parent: "Etiqueta Padre",
    accountTags_id: "ID",
    accountTags_tags: "Etiquetas",
    accountTags_importTags: "Importar Etiquetas",
};